import { React, useEffect, useState, useCallback } from "react";
import styles from "./settingsPage.module.css";
import SearchComp from "../../../components/search/SearchComp";
import LanguagePalsComp from "../../../components/languagePals/LanguagePalsComp";
import LearningZonesComp from "../../../components/learningZonesComp/LearningZonesComp";
import { IoMdSettings } from "react-icons/io";

import SettingsChangePassword from "../../../components/settingsChangePassword/SettingsChangePassword.js";
import SettingsBlockedUsers from "../../../components/settingsBlockedUsers/SettingsBlockedUsers";
import SettingsAccountStatus from "../../../components/settingsAccountStatus/SettingsAccountStatus.js";

import { useUser } from "../../../storage/UserContext"; // context hook
import { useLocation } from "react-router-dom";

const SettingsPage = () => {
  /* The Settings Page contains three tabs: Change Password, Blocked Users, and Account Status. The Change Password tab allows the user to set a new password. The Blocked Users tab allows the user to view the list of users currently blocked by him / her, with the option to unblock a users. The Account Status tab allows the user to check the status of his / her account, with the option to close the account. The page also has quick access side components: Search User, Pals, and Learning Zones. */

  const [activeTab, setActiveTab] = useState("password");
  const location = useLocation();
  const { userData } = useUser();

  const currUsername = userData.username;

  /**
   * Change the active tab, to the one selected by the user.
   */
  const handleTabClick = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  useEffect(() => {
    // Check if there's an activeTab state passed via the navigation
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  return (
    <div className={styles.main}>
      {/* main layout  */}
      <section className={styles.mainLayout}>
        {/* left section  */}
        <div className={styles.left}>
          <LearningZonesComp />
        </div>

        {/* middle section  */}
        <div className={styles.middle}>
          <section className={styles.mainArea}>
            <h1>
              Settings{" "}
              <span className={styles.headerIcon}>
                <IoMdSettings />
              </span>
            </h1>
            <div className={styles.tabsWrapper}>
              <div className={styles.settingsTabs}>
                <button
                  onClick={() => handleTabClick("password")}
                  className={`${styles.tabButton} ${
                    activeTab === "password" ? styles.active : ""
                  }`}
                >
                  Change Password
                </button>
                <button
                  onClick={() => handleTabClick("blocked")}
                  className={`${styles.tabButton} ${
                    activeTab === "blocked" ? styles.active : ""
                  }`}
                >
                  Blocked Users
                </button>
                <button
                  onClick={() => handleTabClick("accountStatus")}
                  className={`${styles.tabButton} ${
                    activeTab === "accountStatus" ? styles.active : ""
                  }`}
                >
                  Account Status
                </button>
              </div>
              <div className={styles.content}>
                {activeTab === "password" && (
                  <SettingsChangePassword currUsername={currUsername} />
                )}
                {activeTab === "blocked" && (
                  <SettingsBlockedUsers currUsername={currUsername} />
                )}
                {activeTab === "accountStatus" && (
                  <SettingsAccountStatus currUsername={currUsername} />
                )}
              </div>
            </div>
          </section>
        </div>

        {/* right section  */}
        <div className={styles.right}>
          <SearchComp />
          <LanguagePalsComp isOwn={true} />
        </div>
      </section>
    </div>
  );
};

export default SettingsPage;
